import { css } from 'styled-components';
import { getBaseTheme } from '@Themes';

const { spaces } = getBaseTheme();

export default css`
    height: 1px;
    margin-top: ${props => (props.marginTop ? `${spaces.default.xxs}` : '0')};
`;
